
export default {
  data: () => ({

    localData: {
      chartData:    [],

      canvasForms:  null,
      canvasChart:  null,

      timeline:     {},
      primary:      {},
      secoundary:   {},

      Chart:        {},
      radio:        null,
      summary:      null,
      keys:         null,
      filters:      null,
      chartIdx:     null,

      current:      null,
    }

  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

}